/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Col, Row, message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import UPDATE_BILLING_NOTE_MUTATION, {
  UpdateBillingNoteVars,
  UpdateBillingNoteData,
} from 'shared/graphql/mutation/updateBillingNote';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button, Text } from 'shared/components';
import { formatDate } from 'shared/utils/dateTime';
import { StyledModal } from './Styles';

type ModalConfirmCreateInvoiceProps = {
  billingNoteId: string;
  invoices: {
    id: string;
    invoiceNumber: string;
    serviceDate: string;
    grandTotalPrice: number;
  }[];
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmAddInvoice: React.FC<ModalConfirmCreateInvoiceProps> = (props) => {
  const { onCancel, visible, invoices, billingNoteId } = props;
  const [updateBillingNote, { loading }] = useMutation<
    UpdateBillingNoteData,
    UpdateBillingNoteVars
  >(UPDATE_BILLING_NOTE_MUTATION, {
    update: (_cache, { data }) => {
      if (data?.updateBillingNote._id) {
        message.success('เพิ่มรายการใบแจ้งหนี้แล้ว');
        onCancel();
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
    refetchQueries: () => ['BillingNote', 'BillingNoteStatus', 'BillingNotes', 'InvoiceStatus'],
  });

  const confirmUpdate = () => {
    updateBillingNote({
      variables: {
        _id: billingNoteId,
        bill_invoice: invoices.map((invoice) => ({ invoice: invoice.id })),
      },
    });
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ยืนยันเพิ่มใบแจ้งหนี้หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="green"
          onClick={() => confirmUpdate()}
          loading={loading}
        >
          เพิ่มใบแจ้งหนี้
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={24}>
          ทั้งหมด <Text strong>{`${invoices.length} รายการ`}</Text>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 0]}>
            <Col span={4}>วันที่เอกสาร</Col>
            <Col span={4}>รหัสใบวางบิล</Col>
            <Col span={4}>มูลค่าใบแจ้งหนี้</Col>
          </Row>

          {invoices.map((invoice) => (
            <Row gutter={[8, 0]}>
              <Col span={4}>
                <Text strong>{formatDate(invoice.serviceDate)}</Text>
              </Col>
              <Col span={4}>
                <Text strong>{invoice.invoiceNumber}</Text>
              </Col>
              <Col span={4}>
                <Text strong customType="primary">
                  {formatCurrency(invoice.grandTotalPrice)}
                </Text>
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmAddInvoice;
